import { Moment } from "moment";
import configurationService from "../../services/configuration/configuration.service";
import moment from 'moment-timezone';

const getConcatedDateTime = (dateMoment: Moment, timeMoment: Moment): string => {
    return moment.tz(dateMoment.format('YYYY-MM-DD') + " " + timeMoment.format('HH:mm:ss'), getSourceTimeZone()).format();
};

const convertUtcStringToLocalString = (dateTimeString: string, outputFormat?: string): string => {
    return moment.tz(dateTimeString, getSourceTimeZone()).format(outputFormat ?? "YYYY-MM-DD HH:mm");
};
const convertUtcStringToSpecificZone = (dateTimeString: string, utcOffset: number, outputFormat?: string): string => {
    return moment.tz(dateTimeString, getSourceTimeZone()).utc().utcOffset(utcOffset).format(outputFormat ?? "YYYY-MM-DD HH:mm");
};

const convertUtcStringToLocalStringDate = (dateTimeString: string, outputFormat?: string): string => {
    return moment.tz(dateTimeString, getSourceTimeZone()).format(outputFormat ?? "YYYY-MM-DD");
}

const convertUtcMomentToLocalString = (dateTimeMoment: Moment, outputFormat?: string): string => {
    return moment.tz(dateTimeMoment, getSourceTimeZone()).format(outputFormat ?? "YYYY-MM-DD HH:mm");

};
const setSourceTimeZone = () => {
    return configurationService.getSetting("PriceSetting.DEFAULT_TIMEZONE").then((response) => {
        localStorage.setItem("sourceTimeZone", response.value);
    });
}
const getSourceTimeZone = () => {
    let value = localStorage.getItem("sourceTimeZone");
    return value ?? "UTC";
}

const convertToTodayDateWithTime = (time: string): Date => {
    const [hours, minutes] = time.split(':').map(Number);
    const today = new Date();

    today.setHours(hours);
    today.setMinutes(minutes);
    today.setSeconds(0);
    today.setMilliseconds(0);

    return today;
};
const convertTimeToNumber = (time: string): number => {
    let hoursMinutes = time.split(/[.:]/);
    let hours = parseInt(hoursMinutes[0], 10);
    let minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
}

const convertObjectDateTimesToUTC = (obj: any): any => {
    if (obj === null || obj === undefined) return obj;

    if (moment.isMoment(obj)) {
        // Directly convert Moment objects to UTC ISO string
        return obj.clone().utc().format();
    }

    if (Array.isArray(obj)) {
        return obj.map(convertObjectDateTimesToUTC);
    }

    if (typeof obj === 'object' && !(obj instanceof FormData)) {
        const newObj: any = {};
        for (const [key, value] of Object.entries(obj)) {
            // If key includes "time" or "date" (case-insensitive)
            if (/(time|date)/i.test(key) && value && typeof value == "string") {
                // Try converting to UTC using moment
                const isDateTimeString = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value);
                if (isDateTimeString) {
                    try {
                        const m = moment(value);
                        if (m.isValid()) {
                            newObj[key] = m.utc().format(); // ISO string in UTC

                        } else {
                            newObj[key] = value; // keep as is if invalid
                        }
                    } catch {
                        newObj[key] = value;
                    }
                } else
                    // skip conversion for plain dates like "2025-09-29"
                    newObj[key] = value;


            } else {
                newObj[key] = convertObjectDateTimesToUTC(value);
            }
        }
        return newObj;
    }

    return obj;
}
// Recursive function to convert any date/time property
const convertObjectDateTimesToLocal = (obj: any): any => {
    if (obj === null || obj === undefined) return obj;

    if (Array.isArray(obj)) {
        return obj.map(convertObjectDateTimesToLocal);
    }

    if (typeof obj === 'object') {
        const newObj: any = {};
        for (const [key, value] of Object.entries(obj)) {
            if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value)) {
                // check if key name suggests a datetime field
                if (/(date|time)/i.test(key)) {
                    let utcMoment = moment.utc(value)
                    const local = moment.tz(utcMoment, getSourceTimeZone()).format(); // convert to local time
                    newObj[key] = local;
                    continue;
                }
            }

            // Recurse for nested objects/arrays
            newObj[key] = convertObjectDateTimesToLocal(value);
        }
        return newObj;
    }

    return obj;
};

const dateTimeHelper = {
    getConcatedDateTime,
    convertUtcStringToLocalString,
    convertUtcStringToLocalStringDate,
    convertUtcMomentToLocalString,
    convertUtcStringToSpecificZone,
    convertToTodayDateWithTime,
    convertTimeToNumber,
    setSourceTimeZone,
    getSourceTimeZone,
    convertObjectDateTimesToUTC,
    convertObjectDateTimesToLocal

};
export default dateTimeHelper;